import type { BundleCartItem as BundleCartItemType } from "../BundleBuilderContext";

import React from "react";

import { useBundleBuilder } from "../BundleBuilderContext";

type BundleCartItemProps = {
  item: BundleCartItemType;
  onRemove: () => void;
};

export const BundleCartItem: React.FC<BundleCartItemProps> = ({
  item,
  onRemove,
}) => {
  const { getVariantData } = useBundleBuilder();
  const { variant, product } = getVariantData(item.variantId, item.productId);
  const image = variant?.featuredImage ?? product?.featured_image;

  return (
    <div
      style={{
        position: "relative",
        width: "80px",
        height: "80px",
        borderRadius: "8px",
        overflow: "hidden",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        backgroundColor: "#f9f9f9",
      }}
    >
      {image ? (
        <img
          src={image}
          alt={variant?.title}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      ) : (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#eee",
          }}
        >
          No image
        </div>
      )}

      {item.quantity > 1 && (
        <div
          style={{
            position: "absolute",
            bottom: "4px",
            right: "4px",
            backgroundColor: "rgba(0,0,0,0.7)",
            color: "white",
            borderRadius: "50%",
            width: "22px",
            height: "22px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "12px",
            fontWeight: "bold",
          }}
        >
          {item.quantity}
        </div>
      )}

      <button
        onClick={onRemove}
        style={{
          position: "absolute",
          top: "4px",
          right: "4px",
          backgroundColor: "rgba(255,255,255,0.8)",
          color: "#333",
          border: "none",
          borderRadius: "50%",
          width: "20px",
          height: "20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "14px",
          fontWeight: "bold",
          cursor: "pointer",
          padding: 0,
        }}
      >
        ×
      </button>
    </div>
  );
};
